/* eslint-disable no-console */
/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./ErrorPromptTapAndGo.css";
import PropTypes from "prop-types";
import { isMobile } from "react-device-detect";

class ErrorPromptTapAndGo extends Component {
  constructor(props) {
    super(props);
    try {
      this.state =
        this.props.location.state || JSON.parse(localStorage.getItem("state"));
    } catch (e) {
      this.props.history.push("/SelectMission");
    }
  }
  render() {
    try {
      const dataObj = this.state;
      const status = this.state.status || "error";
      const languageObj = this.props.t("ErrorPromptTapAndGo".toUpperCase(), {
        returnObjects: true,
      });
      var text = status === "error" ? languageObj.error : languageObj.expired;
      var cancelText =
        status === "error" ? "Choose Other Methods" : "Cancel Payment";
      var cancelLink =
        status === "error"
          ? {
            pathname: "/SelectPayment",
            state: dataObj,
          }
          : "/";
    } catch (e) {
      // console.error(e);
    }
    return (
      <div className="ErrorPromptTapAndGo-view">
        <div className="ErrorPromptTapAndGo-prompt">
          <div className="ErrorPromptTapAndGo-errorIcn"></div>
          <div className="ErrorPromptTapAndGo-text">{text}</div>
          <div
            className="ErrorPromptTapAndGo-closeBtn"
            onClick={() => {
              const dataObj = this.state;
              this.props.history.push({
                pathname: isMobile ? "/TapAndGoCode" : "/TapAndGoCode",
                state: dataObj,
              });
            }}
          ></div>
          <div
            className="ErrorPromptTapAndGo-closeBtn2"
            onClick={() => {
              this.props.history.push(cancelLink);
            }}
          >
            {cancelText}
          </div>
        </div>
      </div>
    );
  }
}
ErrorPromptTapAndGo.propTypes = {
  t: PropTypes.func,
};

export default ErrorPromptTapAndGo;
